import React from 'react';

import classNames from 'classnames';
import castArray from 'lodash/castArray';
import startCase from 'lodash/startCase';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';

const MlFormField = ({
    label,
    name,
    required,
    hint,
    error,
    children,
    className,
    as,
}) => {
    const hasError = error && error.length > 0;
    const labelText = label || (name ? startCase(name) : '');
    const errorText = hasError ? castArray(error).join(', ') : null;

    return (
        <Form.Group
            as={as}
            className={classNames('mb-3 w-100 floating-label', className)}
            controlId={name}
        >
            {labelText && (
                <Form.Label>
                    {required && <abbr title="required">*</abbr>}
                    {required && ' '}
                    {labelText}
                </Form.Label>
            )}
            {children}
            {hint && (
                <Form.Text muted>
                    {hint}
                </Form.Text>
            )}
            {hasError && (
                <Form.Control.Feedback type="invalid" className="d-block">
                    {errorText}
                </Form.Control.Feedback>
            )}
        </Form.Group>
    );
};

MlFormField.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    required: PropTypes.bool,
    hint: PropTypes.string,
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
    ]),
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    as: PropTypes.elementType,
};

export default MlFormField;
